import FormContainer from "@/components/FormContainer";
import { useMenu } from "@/hooks/useMenu";

const Render = ({ form, children }) => {
  if (form) {
    return <FormContainer>{children}</FormContainer>;
  }

  return children;
};

const Content = ({ form, children }) => {
  const { open } = useMenu();

  return (
    <div 
      className={`transition-all duration-300 ${
        open ? "w-[calc(100%-29rem)] ml-[27rem]" : "w-[calc(100%-13.5rem)] ml-[11.5rem]"
      }`}
    >
      <Render form={form}>{children}</Render>
    </div>
  );
};

export default Content;
